module.exports = __webpack_public_path__ + "images/frontpage_mobile@2x.jpg?9923b2dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_mobile@2x.jpg
// module id = 655
// module chunks = 7